export default "__VITE_ASSET__BYM7zM$w__"